import { render, staticRenderFns } from "./SelectUser.modal.vue?vue&type=template&id=61146cf0&"
import script from "./SelectUser.modal.vue?vue&type=script&lang=ts&"
export * from "./SelectUser.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports